import { viewsetDuck } from '@/shared/ducks/viewsetDuck';

export const DEFAULT_STATE = {};

export const duck = viewsetDuck('staffInvoices', '/mgmt/api/invoices/');

export const useMarkApprovedAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-approved/`, { suspense: false, forceEndSlash: true });
};

export const useMarkInvoiceCompletedAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-completed/`, { suspense: false, forceEndSlash: true });
};

export const useMarkCanceledAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-declined/`, { suspense: false, forceEndSlash: true });
};

export const useMarkDeclinedAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-declined/`, { suspense: false, forceEndSlash: true });
};

export const useMarkPaidAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-paid/`, { suspense: false, forceEndSlash: true });
};

export const useMarkPreApprovedAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-preapproved/`, { suspense: false, forceEndSlash: true });
};

export const useRecalculateShipping = (uid) => {
    return duck.useAPI(`${uid}/recalculate-shipping/`, {
        suspense: false,
        forceEndSlash: true,
        target: uid,
    });
};

export const useMarkUnapprovedAPI = (uid) => {
    return duck.useAPI(`${uid}/mark-unapproved/`, { suspense: false, forceEndSlash: true });
};

export const useReissueManyOrders = (uid) => {
    return duck.useAPI(`${uid}/reissue-many-orders/`, { suspense: false, forceEndSlash: true });
};

export const { actionTypes, actions, reducer, useAPI } = duck;

export default duck;
